import api from "./api";

export async function getBankLink(institutionId, userId) {
  const res = await api.post("/bank/connect", { institutionId, userId });
  return res.data.link; // redirect URL
}
